import { render, staticRenderFns } from "./textToVideo.vue?vue&type=template&id=49015b21&scoped=true&"
import script from "./textToVideo.ts?vue&type=script&lang=js&"
export * from "./textToVideo.ts?vue&type=script&lang=js&"
import style0 from "../../comStyle/comStyle.less?vue&type=style&index=0&lang=less&"
import style1 from "./textToVideo.less?vue&type=style&index=1&id=49015b21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49015b21",
  null
  
)

export default component.exports